import {
	ImageWrapper,
	ImagesWrapper,
	InfoWrapper,
	LogoWrapper,
	NoUniqueProductsMessageWrapper,
	Wrapper,
} from './CompareCard.style'

import { BrandAndCluster } from '../../types/brands'
import { ButtonType } from '../../types/common'
import { ProductNoImagePlaceholder } from '../Planogram/PlanogramCard/PlanogramCard.style'
import SelectButton from '../UI/Buttons/SelectButton/SelectButton'
import { css } from 'styled-components'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'
import { filterProducts } from '../../utils/compareProductFilter'
import { useMemo } from 'react'
import { useCompareSkuCategories } from '../../hooks/useCompareSkuCategories'
import ClusterDescriptionLabel from '../ClusterDescriptionLabel/ClusterDescriptionLabel'
import { useTranslation } from 'react-i18next'

type Props = {
	brandAndCluster: BrandAndCluster
}

const CompareCard: React.FC<Props> = ({ brandAndCluster }) => {
	const { t } = useTranslation()
	const { brand, cluster } = brandAndCluster
	const clusterKey = cluster.code + '-' + cluster.month
	const currentFilter = useSelector(
		(state: AppState) => state.cluster.compareProductFilter,
	)

	const { sharedUPCs, uniqueUPCs } = useCompareSkuCategories()

	// Applies filter to products in the current cluster
	const filteredProducts = useMemo(
		() =>
			filterProducts(cluster.products, currentFilter, sharedUPCs, uniqueUPCs),
		[cluster.products, currentFilter, sharedUPCs, uniqueUPCs],
	)

	return (
		<Wrapper>
			<LogoWrapper>
				{brand.urlBrandLogo ? (
					<img src={brand.urlBrandLogo + '?imwidth=300'} alt="brand-logo" />
				) : (
					<span>{brand.brandName}</span>
				)}
			</LogoWrapper>

			{!filteredProducts.length && (
				<NoUniqueProductsMessageWrapper>
					<h1>{t('compare.noUniqueProducts')}</h1>
				</NoUniqueProductsMessageWrapper>
			)}

			<ImagesWrapper>
				{filteredProducts.map(({ imageUrl }, index) => {
					return (
						<ImageWrapper key={`${imageUrl}-${index}`}>
							{imageUrl ? (
								<img src={imageUrl + '?imwidth=300'} alt="product" />
							) : (
								<ProductNoImagePlaceholder />
							)}
						</ImageWrapper>
					)
				})}
			</ImagesWrapper>
			<InfoWrapper>
				<ClusterDescriptionLabel
					clusterLabel={cluster.clusterLabel}
					variant="dark"
				/>

				<SelectButton
					type={ButtonType.CLUSTER}
					key={clusterKey}
					cluster={cluster}
					brandGroup={brand.group}
					customStyle={css`
						box-shadow: none;
					`}
				/>
			</InfoWrapper>
		</Wrapper>
	)
}

export default CompareCard
